import React from "react";

const input = (props) => {
  return (
    <>
      <label
        aria-label={props.label}
        htmlFor={props.htmlFor}
        className="block flex justify-between text-sm font-medium text-gray-300"
      >
        {props.label}
        <span id={props.spID} className="text-sm text-gray-500">
          {props.support}
        </span>
      </label>

      <div className="mt-1">
        <input
          type={props.type}
          name={props.name}
          id={props.id}
          aria-describedby={props.aria}
          autoComplete={props.autoComplete}
          className="block w-full np-input text-gray-900 border-gray-300 rounded-md shadow-sm focus:border-cyan-500 focus:ring-cyan-500"
        />
      </div>
    </>
  );
};

export default input;
